import React, { useMemo } from 'react';
import styles from './multiStageProgress.module.css';
import IMAGES from '../../assets/images/images';
import { buildProgressFromStates, iconForStageLabel } from '../../utils/arrayUtils';
import { STAGE_LABEL_MAP } from '../../utils/constants/DemandConstant';

export default function MultiStageProgress({
  demandCreated=false,
  workflowStages = [],
  onStatePick,
  selectedStageIndex = null,         // NEW: which past stage is currently "selected" for viewing
  stageIcons = IMAGES,
}) {
  const hasStages = Array.isArray(workflowStages) && workflowStages.length > 0;

  // Build progress for UI visuals
  const stagesUI = useMemo(() => {
    if (!hasStages) return [];
    return workflowStages;
  }, [hasStages, workflowStages]);

  // On click, emit selected index and stage.
  const chooseStateForStage = (stageIndex) => {
    if (!hasStages) return;
    console.log("stageIndex",stagesUI[stageIndex]);
    
    const payload = {
      selectedStage:stagesUI[stageIndex]?.label || "",
      selectedStageIndex:stageIndex,
    };
    onStatePick?.(payload);
  };

  if (!hasStages) {
    return <div className={styles.progressContainer} aria-hidden="true" />;
  }

  return (
    <div className={styles.progressContainer} role="group" aria-label="Progress steps">
      <ul
        className={styles.progressSteps}
        style={{ gridTemplateColumns: `40px repeat(${stagesUI.length-1}, 1fr)` }}
      >
        {stagesUI.map((stage, i) => {
          const isComplete = stage.percentComplete >= 100;
          const isActive = stage.isActive && stage.percentComplete < 100
          const imgObj = iconForStageLabel(stage.label, stageIcons);
          const isClickable = stage.reachedStates?.length !=0;
          const isSelected = selectedStageIndex === i;


          let iconToShow = imgObj?.neutral;
          if (isActive || isComplete) {
            iconToShow = imgObj?.filled;
          }
          const dotStateClass = isComplete
            ? styles.dotComplete
            : isActive
              ? styles.dotActive
              : styles.dotNeutral;

          const handleClick = () => {
            if (!isClickable) return;
            chooseStateForStage(i);
          };

          const handleKeyDown = (e) => {
            if (!isClickable) return;
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              chooseStateForStage(i);
            }
          };
          const displayLabel = STAGE_LABEL_MAP[stage.label] ?? stage.label;
          return (
            <li
              key={stage.id ?? stage.label ?? i}
              className={`${styles.progressStep} ${stage.isActive ? styles.active : ''} ${isSelected ? styles.selected : ''}`}
              onClick={isClickable ? handleClick : undefined}
              onKeyDown={handleKeyDown}
              role={isClickable ? 'button' : 'listitem'}
              aria-disabled={!isClickable}
              tabIndex={isClickable ? 0 : -1}
              style={{ cursor: isClickable ? 'pointer' : 'not-allowed' }}
            >
              <div className={styles.segment}>
                <div className={styles.segmentTrack} aria-hidden="true" />
                <div
                  className={`${styles.segmentFill} ${isComplete ? styles.fillComplete : ''} ${isActive ? styles.fillActive : ''}`}
                  aria-hidden="true"
                  style={{ width: `${stage.percentComplete}%` }}
                />
                <div
                  className={`${styles.progressDot} ${dotStateClass} ${!isClickable ? styles.dotDisabled : ''} ${isSelected ? styles.dotSelected : ''} ${i===0 && demandCreated&& styles.demandactive }`}
                  role="img"
                  aria-label={`${stage.label} ${stage.percentComplete}%`}
                >
                  {iconToShow ? (
                    <>
                    <img
                      src={iconToShow}
                      alt={`${stage.label} icon`}
                      className={styles.dotImage}
                      draggable="false"
                    />
                    <div className={`${styles.progressLabel} ${isComplete && !demandCreated ? styles.txtComplete : ''} ${isActive ? styles.txtActive : ''} ${i===0 && demandCreated&& styles.txtActive }`}>{displayLabel}</div>
                    </>
                  ) : (
                    <span className={styles.dotNumber} aria-hidden="true">{i + 1}</span>
                  )}
                </div>
              </div>
              {/* {(stage.isActive && stage.percentComplete < 100) && (
                <div className={styles.currentstage} title={stage.label}>
                  In progress
                </div>
              )}
              {(stage.isActive && stage.percentComplete === 100 && !demandCreated) && (
                <div className={styles.currentstage} title={stage.label}>
                  Completed
                </div>
              )} */}
            </li>
          );
        })}
      </ul>
    </div>
  );
}